import { path } from 'ramda';

import { NAME } from './constants';

export const getClients = path([NAME]);
